import { AvatarProps } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import { getInitials } from '@sonar-software/sonar-ts-lib';
import { SonarAvatar } from './SonarAvatar';
import React, { useEffect } from 'react';
import { useAction, useCurrentUser, useUserReference } from '@hooks';

const fiveMinutes = 5 * 60 * 1000;

function requiresRefresh(profilePictureTimestamp: number | undefined): boolean {
	if (!profilePictureTimestamp) {
		return true;
	}

	return Date.now() - fiveMinutes > profilePictureTimestamp;
}

export interface UserAvatarProps {
	className?: string;
	large?: boolean;
	shape?: AvatarProps['shape'];
	userId: number;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ className, large, shape, userId }) => {
	const { isGuest } = useCurrentUser();
	const { firstName, lastName, profilePicture, profilePictureTimestamp } = useUserReference(userId);

	const getProfilePicture = useAction(coreActions.requestGetCoreUsersByIdPicture);

	useEffect(() => {
		if (userId !== -1 && !isGuest && requiresRefresh(profilePictureTimestamp)) {
			getProfilePicture({ userId });
		}
	}, [ getProfilePicture, isGuest, profilePictureTimestamp, userId ]);

	const initials = getInitials(firstName, lastName);

	return (
		<SonarAvatar
			className={ className }
			isPlaceholder={ userId === -1 }
			large={ large }
			shape={ shape }
			src={ profilePicture }>
			{ initials }
		</SonarAvatar>
	);
};
